import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaEnvelope,
  FaLock,
  FaKey,
  FaArrowLeft,
} from 'react-icons/fa';

const ResetPasswordForm = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [status, setStatus] = useState({
    message: '',
    type: '',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    setStatus({
      message: '',
      type: '',
    });

    try {
      const res = await fetch(
        'https://ikaze-thouse-backend.vercel.app/api/v1/auth/change-password',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },

          body: JSON.stringify({
            email,
            newPassword,
          }),
        }
      );

      const data = await res.json();

      if (data.success) {
        setStatus({
          message: data.message,
          type: 'success',
        });

        setEmail('');
        setNewPassword('');

        // Redirect after success
        setTimeout(() => {
          navigate('/login');
        }, 2000);

      } else {
        setStatus({
          message: data.message,
          type: 'error',
        });
      }

    } catch (err) {
      console.error(err);

      setStatus({
        message: 'Server error',
        type: 'error',
      });
    }
  };

  const styles = {
    page: {
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundImage:
        'linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url("https://a0.muscache.com/im/pictures/miso/Hosting-1205138042877593664/original/0d94964b-e1b9-4c9a-bafa-d9f8632dcc9d.jpeg?im_w=1200")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      padding: '20px',
      fontFamily: 'Segoe UI, sans-serif',
    },

    card: {
      width: '100%',
      maxWidth: '430px',
      background: 'rgba(255,255,255,0.96)',
      borderRadius: '20px',
      padding: '35px',
      boxShadow: '0 10px 35px rgba(0,0,0,0.3)',
      backdropFilter: 'blur(6px)',
      animation: 'fadeIn 0.5s ease',
    },

    logoCircle: {
      width: '85px',
      height: '85px',
      borderRadius: '50%',
      background: 'linear-gradient(135deg, #007bff, #00c6ff)',
      margin: '0 auto 20px auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#fff',
      fontSize: '32px',
      boxShadow: '0 6px 18px rgba(0,123,255,0.4)',
    },

    heading: {
      textAlign: 'center',
      fontSize: '30px',
      fontWeight: 'bold',
      color: '#222',
      marginBottom: '8px',
    },

    subText: {
      textAlign: 'center',
      color: '#666',
      marginBottom: '30px',
      fontSize: '14px',
    },

    inputGroup: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '20px',
      border: '1px solid #ddd',
      borderRadius: '12px',
      overflow: 'hidden',
      background: '#f8f9fa',
      transition: '0.3s',
    },

    iconBox: {
      width: '55px',
      height: '55px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'linear-gradient(135deg, #007bff, #00c6ff)',
      color: '#fff',
      fontSize: '18px',
    },

    input: {
      flex: 1,
      border: 'none',
      outline: 'none',
      padding: '15px',
      fontSize: '15px',
      background: 'transparent',
      color: '#333',
    },

    button: {
      width: '100%',
      padding: '15px',
      border: 'none',
      borderRadius: '12px',
      background: 'linear-gradient(135deg, #007bff, #00c6ff)',
      color: '#fff',
      fontSize: '17px',
      fontWeight: 'bold',
      cursor: 'pointer',
      boxShadow: '0 5px 15px rgba(0,123,255,0.35)',
      transition: '0.3s',
    },

    message: {
      textAlign: 'center',
      marginBottom: '18px',
      fontWeight: 'bold',
      fontSize: '14px',
    },

    backButton: {
      marginTop: '18px',
      textAlign: 'center',
      color: '#007bff',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      fontWeight: 'bold',
      fontSize: '14px',
    },
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>

        {/* ICON */}
        <div style={styles.logoCircle}>
          <FaKey />
        </div>

        {/* TITLE */}
        <h2 style={styles.heading}>
          Change Password
        </h2>

        <p style={styles.subText}>
          Enter your email and create a new secure password
        </p>

        {/* STATUS MESSAGE */}
        {status.message && (
          <p
            style={{
              ...styles.message,
              color: status.type === 'success'
                ? 'green'
                : 'red',
            }}
          >
            {status.message}
          </p>
        )}

        {/* FORM */}
        <form onSubmit={handleSubmit}>

          {/* EMAIL */}
          <div style={styles.inputGroup}>
            <div style={styles.iconBox}>
              <FaEnvelope />
            </div>

            <input
              type="email"
              placeholder="Enter Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              required
            />
          </div>

          {/* PASSWORD */}
          <div style={styles.inputGroup}>
            <div style={styles.iconBox}>
              <FaLock />
            </div>

            <input
              type="password"
              placeholder="Enter New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              style={styles.input}
              required
            />
          </div>

          {/* BUTTON */}
          <button type="submit" style={styles.button}>
            Update Password
          </button>

        </form>

        {/* BACK TO LOGIN */}
        <div
          style={styles.backButton}
          onClick={() => navigate('/login')}
        >
          <FaArrowLeft />
          Back to Login
        </div>

      </div>
    </div>
  );
};

export default ResetPasswordForm;